import { useEffect } from "react";
import { useQuery } from "@apollo/client";
import { useAppDispatch } from "../redux/hooks";
import { setPermissions } from "../redux/reducers";
import { GET_ACCESS } from "../apolloClient/operation/querys/userQuery";
import { RolePermission } from "../types/interface";

export const useAccess = () => {
  const dispatch = useAppDispatch();

  const { data, error, loading } = useQuery<{ getAccess: RolePermission[] }>(
    GET_ACCESS,
    { fetchPolicy: "network-only" } 
  );

  useEffect(() => {
    if (error) {
      console.error("Error fetching access permissions:", error);
    }

    if (data && data.getAccess) {
      dispatch(setPermissions(data.getAccess));
    }
  }, [data, error, dispatch]);

  return { loading, error, permissions: data?.getAccess || [] };
};
